import { Collection, ModelBase, ObservableCollection, Property } from '@skylab-shared/core';
import { DdkState } from '../accountancy/ddk-state';
import { CalculationMethod } from '../common/calculation-method';
import { EppState } from '../common/epp-state';
import { DocumentClientModel } from '../document/document-client.model';
import { DocumentPaymentListItemModel } from '../document/document-payment-list-item.model';
import { ExchangeRateModel } from '../exchange-rate/exchange-rate.model';
import { KsefReceivedDocumentKind } from '../ksef/ksef-received-document-kind';
import { KsefSendSubmissionMode } from '../ksef/ksef-send-submission-mode';
import { SplitPaymentState } from '../sale/split-payment-state';
import { VatTableItemModel } from '../vat-table/vat-table-item.model';
import { PurchaseBankAccountModel } from './purchase-bank-account.model';
import { PurchaseDocumentKind } from './purchase-document-kind';
import { PurchaseEInvoiceDocumentItemModel } from './purchase-e-invoice-document-item.model';

export class PurchaseEInvoiceDocumentModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public favourite: boolean;

    @Property()
    public cashBasis: boolean;

    @Property(DocumentClientModel, {nullable: true})
    public seller: DocumentClientModel | null;

    @Property(PurchaseBankAccountModel,{nullable: true})
    public bankAccount: PurchaseBankAccountModel | null;

    @Property(String, {nullable: true})
    public calculationMethod: CalculationMethod.Net | CalculationMethod.Gross | CalculationMethod.Manual | null;

    @Property()
    public ksefDocumentId: string;

    @Property()
    public ksefDocumentKind: KsefReceivedDocumentKind;

    @Property({ nullable: false })
    public ksefSubmissionMode: KsefSendSubmissionMode;

    @Property({nullable: true})
    public dateOfAssigningKsefNumber?: Date;

    @Property()
    public communityTransactionId: number;

    @Property(String, {nullable: true})
    public transactionLocation: string | null;

    @Property()
    public currencyId: number;

    @Property(Date, {nullable: true})
    public issueDate: Date | null;

    @Property()
    public issuedByVatPayer: boolean;

    @Property({ nullable: true })
    public deliveryDate: Date;

    @Property(Date, {nullable: true})
    public receiptDate: Date | null;

    @Property({ nullable: true })
    public vatDeductionDate: Date;

    @Property()
    public grossValue: number;

    @Property(Number, {nullable: true})
    public currencyGrossValue: number | null;

    @Property()
    public netValue: number;

    @Property()
    public documentNumber: string;

    @Property(Date, {nullable: true})
    public dueDate: Date | null;

    @Property(Number, {nullable: true})
    public dueDateDays: number | null;

    @Property(String, {nullable: true})
    public customDueDateDescription: string | null;

    @Collection({ type: DocumentPaymentListItemModel })
    public payments: ObservableCollection<DocumentPaymentListItemModel>;

    @Property(ExchangeRateModel, {nullable: true})
    public exchangeRate: ExchangeRateModel | null;

    @Property()
    public externalDocumentNumber: string;

    @Property()
    public fixedAsset: boolean;

    @Property()
    public jpkVatGroups: string[];

    @Property({nullable: true})
    public ksefHeaderId: number;

    @Property({nullable: true})
    public ksefHash: string;

    @Property(String, { nullable: true })
    public ksefCollectiveIdentifier?: string | null;

    @Property()
    public readonly kind: PurchaseDocumentKind = PurchaseDocumentKind.EPurchaseInvoice;

    @Property()
    public note: string;

    @Collection({ type: PurchaseEInvoiceDocumentItemModel })
    public items: ObservableCollection<PurchaseEInvoiceDocumentItemModel>;

    @Property()
    public numberingId: number;

    @Property()
    public paymentMethodId: number;

    @Property()
    public splitPayment: SplitPaymentState;

    @Collection({ type: VatTableItemModel })
    public vatTableItems: ObservableCollection<VatTableItemModel>;

    @Collection({ type: VatTableItemModel })
    public vatTableItemsInBaseCurrency: ObservableCollection<VatTableItemModel>;

    @Property(String, {nullable: true})
    public recipient: string | null;

    @Property(String, {nullable: true})
    public issuer: string | null;

    @Property()
    public ddkState: DdkState;

    @Property()
    public eppState: EppState;
}
